var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class DataService {
    constructor() {
        this._collection = {};
    }
    collection() {
        return this._collection;
    }
    gather(endpoint) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._collection[endpoint] == undefined) {
                this._collection[endpoint] = yield this.fetch(endpoint);
            }
        });
    }
    fetch(endpoint) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                // @ts-ignore
                const url = (["netherlands", "licences2023"].indexOf(endpoint) > -1) ? './' + endpoint + '.geojson' : DOMAIN + APIBASE + endpoint;
                const response = yield fetch(url);
                if (response.ok) {
                    resolve(response.json());
                }
                else {
                    reject();
                }
            }));
        });
    }
}
